function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledEmptyStateComponent } from "segments/desktop/careers/layouts/positions-careers/empty-state/empty-state-component.scss";
import AssetComponent from "components/core/asset/asset-component";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
const DEFAULT_FULL_PARAGRAPH_PROPS = {
    topic: {}
};
const EmptyStateComponent = ({ asset, fullParagraph, emptyStateAdvancedConfig })=>/*#__PURE__*/ _jsxs(StyledEmptyStateComponent, {
        children: [
            /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, asset, emptyStateAdvancedConfig === null || emptyStateAdvancedConfig === void 0 ? void 0 : emptyStateAdvancedConfig.assetAdvancedConfig)),
            /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph, DEFAULT_FULL_PARAGRAPH_PROPS, emptyStateAdvancedConfig === null || emptyStateAdvancedConfig === void 0 ? void 0 : emptyStateAdvancedConfig.fullParagraphAdvancedConfig))
        ]
    });
export default EmptyStateComponent;
